import { useTranslation } from 'react-i18next'
import Container from '@/components/ui/container'

export default function RoadmapHero() {
  const { t } = useTranslation()

  return (
    <section className="py-20 md:py-32 lg:py-40">
      <Container className="text-center">
        <h1 className="font-display text-3xl sm:text-4xl md:text-display-lg lg:text-[5rem] font-extrabold tracking-tighter leading-[0.95] mb-8 animate-hero-reveal">
          {t('roadmap.hero.headingLine1')}
          <br />
          <span className="bg-gradient-to-r from-primary to-primary-container bg-clip-text text-transparent">
            {t('roadmap.hero.headingLine2')}
          </span>
        </h1>
        <p
          className="text-on-surface-variant text-lg md:text-xl max-w-3xl mx-auto leading-relaxed animate-hero-reveal"
          style={{ animationDelay: '0.15s' }}
        >
          {t('roadmap.hero.description')}
        </p>
      </Container>
    </section>
  )
}
